/**
 * Scroll Header — adds .scroll class to body when user scrolls down
 */
(function () {
  'use strict';

  var SCROLL_THRESHOLD = 50;
  var body = document.body;
  var ticking = false;

  function updateScrollClass() {
    var scrolled = window.scrollY > SCROLL_THRESHOLD;
    body.classList.toggle('scroll', scrolled);
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateScrollClass);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // Initial check on load
  updateScrollClass();
})();
